import { Graphviz } from 'graphviz-react';
import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'src/api/client';
import { Flex } from '@chakra-ui/react';
import useCurrentContextId from 'src/hooks/useCurrentContextId';

function Graph(props: {
  submissionContextId: string;
  type: 'submission' | 'review';
}) {
  const id = props.submissionContextId;
  const { data, error } = useQuery({
    queryKey: ['submissionContextWorkflowGraph', id, props.type],
    queryFn: () =>
      axiosInstance
        .get<{ graphs: string[] }>(
          `/submission-contexts/${id}/graph/${props.type}`
        )
        .then(r => r.data)
  });

  if (error) return <div>error</div>;
  if (!data) return <div>loading</div>;

  return (
    <div>
      <div>{props.type}</div>
      {data.graphs.map((graph, i) => (
        <Graphviz
          key={i}
          dot={graph}
          options={{ fit: true, width: 1500, zoom: false }}
        />
      ))}
    </div>
  );
}

const WorkflowGraph = () => {
  const submissionContextId = useCurrentContextId() ?? '';

  return (
    <Flex>
      <Graph submissionContextId={submissionContextId} type="submission" />
      {/* <Graph submissionContextId={submissionContextId} type="review" /> */}
    </Flex>
  );
};

export default WorkflowGraph;
